/**
 * 视频草稿卡上的「这份稿子正在干什么」。
 *
 * ═══ 这是「信息被丢了」,不是「信息没有」═══════════════════════════════════════
 * 老板走查(2026-08-19):「我如果点了编排,是否状态就应该是编排中或者什么,而不是落入草稿」。
 *
 * 服务端**一直知道**:`VideoDraftDto.frameGenStatus` 由 backend 从 draftMeta 解出来。
 * 但只有创建页在读它 —— `pages/works/model/workLines.ts` 把视频草稿映射成 `WorkDraft` 时
 * 整个丢掉了这个字段(`WorkDraft` 类型里压根没有状态位)。于是点了「AI 智能编排」、
 * 关掉页面、去作品页看到的就是一张**普通草稿卡**,与没编排过的一模一样。
 *
 * ★这一条只补最后一跳(A 档):把已经在链路里的事实显示出来。
 *   把编排提升成一等任务对象(独立列表项 + 状态机,C 案 `xb_media_draft_job` 骨架现成)
 *   是 B 档,涉及三仓与列表 IA,不在这里。
 *
 * ★认不出来的值一律当没有:后端将来加新态时,页面显示一个原始枚举名比不显示更糟。
 */

/** 与创建页 `frameGenStatus` 同一套词汇(IDLE/COMPOSING/RUNNING/DONE/PARTIAL/FAILED/COMPOSE_FAILED)。 */
const HINTS: Record<string, string> = {
  COMPOSING: "编排中",
  RUNNING: "出台本图中",
  COMPOSE_FAILED: "编排失败",
  FAILED: "出图失败",
  PARTIAL: "部分镜没出成",
};

export function draftStatusHint(frameGenStatus?: string | null): string | undefined {
  if (!frameGenStatus) return undefined;
  return HINTS[frameGenStatus];
}

/** 这份草稿是不是**还在跑** —— 列表据此决定要不要轮询(与创建页在途判据同源)。 */
export function draftInFlight(frameGenStatus?: string | null): boolean {
  return frameGenStatus === "COMPOSING" || frameGenStatus === "RUNNING";
}
